import {Component} from '@angular/core';

import {VendorsModule} from "../../vendors.module";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'lib-keyboard-shortcuts-dialog',
    imports: [
    VendorsModule
],
    templateUrl: './keyboard-shortcuts-dialog.component.html',
    styleUrl: './keyboard-shortcuts-dialog.component.css'
})
export class KeyboardShortcutsDialogComponent {

  constructor(public dialogRef: MatDialogRef<KeyboardShortcutsDialogComponent>) {}

  readonly KEYBOARD_SHORTCUTS = [
    {
      section: 'Order Menu (Food Selection)',
      shortcuts: [
        { key: 'Double Space', description: 'Focus search field' },
        { key: 'Tab', description: 'Navigate categories down' },
        { key: 'Shift + Tab', description: 'Navigate categories up' },
        { key: '↑ ↓ ← →', description: 'Navigate food items in grid' },
        { key: 'Enter', description: 'Open add-to-cart dialog for selected food' },
        { key: 'Escape', description: 'Cancel order (with confirmation)' },
        { key: 'Backspace', description: 'Go back to previous page' },
      ]
    },
    {
      section: 'Add to Cart Dialog',
      shortcuts: [
        { key: '↑ / +', description: 'Increase quantity' },
        { key: '↓ / -', description: 'Decrease quantity' },
        { key: 'Enter', description: 'Add to cart' },
        { key: 'Escape', description: 'Close dialog' },
      ]
    },
    {
      section: 'Order Cart',
      shortcuts: [
        { key: 'Shift + ↑', description: 'Navigate cart items up' },
        { key: 'Shift + ↓', description: 'Navigate cart items down' },
        { key: 'Delete', description: 'Delete selected cart item' },
        { key: 'Escape', description: 'Clear cart selection' },
        { key: 'Ctrl + S', description: 'Create order (stay on page)' },
        { key: 'Ctrl + P', description: 'Print KOT' },
        { key: 'Double Enter', description: 'Checkout' },
      ]
    },
    {
      section: 'General',
      shortcuts: [
        { key: '?', description: 'Open keyboard shortcuts help dialog' },
      ]
    }
  ];

  close(): void {
    this.dialogRef.close();
  }
}
